<template>
    <b-card no-body>
      <b-card-body class="p-1">
        <div class="d-inline-flex align-items-center w-100">
          <b-button
            variant="gradient-primary"
            size="sm"
            class="mr-1"
            :disabled="loading"
            @click="traerRegistros"
          >
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
          <!-- <b-button
            variant="success"
            size="sm"
            class="mr-1"
            :disabled="loading"
            @click="exportarExcel"
          >
            <feather-icon icon="DownloadIcon" />
          </b-button> -->
        </div>
      </b-card-body>
      <b-table
        hover
        responsive
        small
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(volveria_trabajar)="data">
          <span>
            {{ data.value === true ? 'Sí' : data.value === false ? 'No' : '' }}
          </span>
        </template>        
        <template #cell(created)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value).toLocaleString('es-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="perPageSelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
  </template>
  
  <script>
  import axiosIns from '../../libs/axios'
  import {
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BCardBody,
    BSpinner,
  } from 'bootstrap-vue'
  
  export default {
    components: {
      BCard,
      BTable,
      BFormGroup,
      BFormSelect,
      BPagination,
      BButton,
      BCardBody,
      BSpinner,
    },
    data() {
      return {
        perPage: 15,
        pageOptions: [15, 25, 50],
        totalRows: 1,
        currentPage: 1,
        loading: false,
        items: [],
        fields: [
          { key: 'dni_responsable', label: 'DNI Responsable', sortable: true },
          { key: 'departamento', label: 'Departamento', sortable: true },
          { key: 'distrito', label: 'Distrito', sortable: true },
          { key: 'centro_poblado', label: 'Centro Poblado', sortable: true },
          { key: 'paradero', label: 'Paradero', sortable: true },
          { key: 'direccion', label: 'Dirección', sortable: false },
          { key: 'celular', label: 'Celular', sortable: false },
          { key: 'whatsapp', label: 'Whatsapp', sortable: false },
          { key: 'motivo_falta', label: 'Motivo Falta', sortable: false },
          { key: 'motivo_falta_otros', label: 'Otro Motivo de Falta', sortable: false },
          { key: 'volveria_trabajar', label: '¿Volvería a Trabajar?', sortable: false },
          { key: 'motivo_no_volver', label: 'Motivo No Volver', sortable: false },
          { key: 'semana_ingreso', label: 'Semana Ingreso', sortable: false },
          { key: 'cambio_domicilio', label: '¿Cambio Domicilio?', sortable: false },
          { key: 'aspecto_dificil', label: 'Aspecto Difícil', sortable: false },
          { key: 'apoyo_empresa', label: 'Apoyo Empresa', sortable: false },        
        ],
      }
    },
    mounted() {
      this.traerRegistros()
    },
    methods: {
      traerRegistros() {
        this.loading = true
        axiosIns.get('/trabajaenagrovision/registrosreclutamiento/')
          .then(response => {
            // Los campos ya vienen como texto directo, no necesitan mapeo
            this.items = response.data
            this.totalRows = this.items.length
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
      },

      /* exportarExcel() {
        this.loading = true
        axiosIns.post('/trabajaenagrovision/registrosreclutamiento/exportar/', {}, {
          responseType: 'blob'
        })
          .then(response => {
            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'reclutamiento.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
          })
          .catch(error => {
            this.$bvToast.toast('No se pudo exportar el archivo.', {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
            console.error(error)
          })
          .finally(() => {
            this.loading = false
          })
      } */
    },
  }
  </script>
  